module.exports = __webpack_public_path__ + "static/media/mercedes_benz.6551593c.svg";